// extracted by mini-css-extract-plugin
export default {"emptyScreenImg":"EmptyScreen-module__emptyScreenImg__vp8qw","rateButton":"EmptyScreen-module__rateButton__pFGZS"};